<template>
  <div 
    class="base-progress-bar" 
    v-on="$listeners"
  >
    <div class="base-progress-bar__background">
      <div
        :style="baseProgressBarIndicatorStyles"
        :class="baseProgressBarIndicatorClasses"
        class="base-progress-bar__indicator"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
  yellow: {
    type: Boolean,
    default: false,
  },
  green: {
    type: Boolean,
    default: false,
  },
});

const baseProgressBarIndicatorStyles = computed(() => ({
  width: `${props.progress}%`,
}));

const baseProgressBarIndicatorClasses = computed(() => ({
  "base-progress-bar__indicator--green": props.progress >= 100 || props.green,
  "base-progress-bar__indicator--yellow": props.yellow,
}));
</script>

<style lang="scss" scoped>
@import "./base-progress-bar.scss";
</style>
